module.exports = __webpack_public_path__ + "img/left.0a84d479.svg";